import ycloud from 'ycloud'
import 'ycloud/dist/bootstrap.css'
import 'ycloud/dist/ycloud.min.css'
import './router'
window.ycloud = ycloud
// cpu-cdn/css/plugins/fontawesome/fontawesome-free-5.0.10/css/fontawesome-all.css



// WEBPACK FOOTER //
// ./src/app.js